module.exports = __webpack_public_path__ + "static/media/sent_coupon_1.31455883.svg";